import React from "react";
// import { ReactComponent as LogoMarket } from "../../rsc/market.svg"
import Companies from "../companies/Companies";
import CompanyDetail from "../companies/CompanyDetail";
// import Market from "../market/Market"
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { Route, Routes } from "react-router";
import { useNavigate } from "react-router-dom";
import '../../global.scss';
import { AdminInfo } from "../../stores/store";
import { MillBusiness } from "../business/MillBusiness";
import OrganisationProfile from "../companies/OrganisationProfile";
import Dashboard from "../dashboard/Dashboard";
import { InvoiceDetail } from "../invoice/InvoiceDetail";
import { PempemInvoiceList } from "../invoice/PempemInvoiceList";
import { MyPrices } from "../my_prices/MyPrices";
import { Profile } from "../profil/Profile";
import { StatementPage } from "../statement/StatementPage";
import { SpecialPrices } from "../special_prices/SpecialPrices";
import { SupplierPage } from "../supplier/SupplierPage";
import { TodayDeliveryPage } from "../contracts/TodayDeliveryPage";
import { TraceCompletedContracts } from "../traceability/TraceCompletedContracts";
import { PempemDecodeUrl } from "../invoice/PempemDecodeUrl";
import { PempemInvoiceDetail } from "../invoice/PempemInvoiceDetail";
import CompanyDetailAdmin from "../companies/CompanyDetailAdmin";
import { Admin } from "../dashboard/Admin";

type ExplorerType = {
    client: ApolloClient<NormalizedCacheObject>,
    isAdmin: AdminInfo,
    logOut: () => void,
    menuOpen: boolean
}

function Explorer({ client, isAdmin }: ExplorerType) {

    const navigate = useNavigate()

    // Footer height
    return <div id="explorer" className="flex" style={{ minHeight: "100vh - 64px" }}>
        <div style={{ flexGrow: "1", minHeight: "calc(100vh - 64px)" }}>
            <Routes>
                <Route path="companies" element={<Companies client={client} onViewMoreClick={(org) => {
                    navigate(`companies/company_detail/${org.id}`)
                }} />}></Route>
                {/* <Route path="market" element={<Market client={client} />}></Route> */}
                <Route path="today_delivery/*" element={<TodayDeliveryPage client={client} />}></Route>
                <Route path="purchases/*" element={<TraceCompletedContracts client={client} />}></Route>
                <Route path="my_prices" element={<MyPrices client={client} />}></Route>
                <Route path="profile" element={<Profile client={client} />}></Route>
                <Route path="pempem_invoices/*" element={<PempemInvoiceList />}></Route>
                {/* <Route path="price_vision" element={<PriceVisionPage client={client} />}></Route> */}
                <Route path="companies/company_detail/" element={<CompanyDetail client={client} />}></Route>
                <Route path="company_profil/:id" element={<OrganisationProfile client={client} />}></Route>
                <Route path="statement" element={<StatementPage />}></Route>
                <Route path="suppliers" element={<SupplierPage />}></Route>
                <Route path="special_prices" element={<SpecialPrices />}></Route>
                <Route path="business" element={<MillBusiness />}></Route>
                <Route path="invoice_pempem_decode" element={<PempemDecodeUrl />} />
                <Route path="invoice_pempem_detail" element={<PempemInvoiceDetail />} />
                <Route path="company_admin_detail/:id" element={<CompanyDetailAdmin/>} />
                <Route path="invoice_detail/*" element={<InvoiceDetail client={client} />}></Route>
                {
                    isAdmin.dashboardEnable ?
                        <Route path="dashboard/*" element={<Dashboard client={client} />}></Route>
                        : <></>
                }
                <Route path="admin/" element={<Admin />}></Route>
            </Routes>
        </div>
    </div>
}

export default Explorer